import _ from 'lodash';
export const checkActivePrice = (priceSettings) => {
  const data = _.cloneDeep(priceSettings || {});
  const flag = false;
  // const { defaultSalePrice } = data;
  // if (!defaultSalePrice) {
  //   flag = true;
  //   data.defaultSalePriceError = true;
  // }
  return { flag, data };
};
